import script from "./ShipToContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipToContacts.vue?vue&type=script&setup=true&lang=js"

import "./ShipToContacts.vue?vue&type=style&index=0&id=3ace340a&lang=scss"

const __exports__ = script;

export default __exports__